import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { ImpersonationBanner } from './ImpersonationBanner';
import { SidebarProvider } from '@/contexts/SidebarContext';
import { BreadcrumbProvider } from '@/contexts/BreadcrumbContext';
import { cn } from '@/lib/utils';

function AdminLayoutContent() {
  return (
    // Variantes print : à l'impression (export PDF du rapport de migration),
    // on masque la navigation et on laisse le contenu s'étendre sur la page.
    <div className="flex h-screen overflow-hidden print:block print:h-auto print:overflow-visible">
      <div className="print:hidden contents">
        <Sidebar />
      </div>
      <div
        className={cn(
          // min-w-0 : sans ça, un contenu large (tableaux) empêche cette colonne
          // flex de rétrécir sous la largeur du viewport → débordement + contenu
          // rogné à droite. Avec min-w-0, la colonne respecte la largeur dispo et
          // les tableaux scrollent horizontalement dans leur propre conteneur.
          'flex min-w-0 flex-1 flex-col overflow-hidden transition-all duration-300 print:block print:overflow-visible',
          'lg:ml-0' // Sidebar is relative on desktop
        )}
      >
        <div className="print:hidden contents">
          <ImpersonationBanner />
          <Header />
        </div>
        <main className="flex-1 overflow-y-auto bg-muted/30 p-4 md:p-6 print:overflow-visible print:bg-white print:p-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export function AdminLayout() {
  return (
    <SidebarProvider>
      <BreadcrumbProvider>
        <AdminLayoutContent />
      </BreadcrumbProvider>
    </SidebarProvider>
  );
}
